<template>
  <div>
    <AppIcon v-if="icon" :icon="iconClass" />
    <slot v-else />
  </div>
</template>

<script>
import { Tooltip } from 'bootstrap'

export default {
  props: {
    icon: {
      type: [String, Boolean],
      default: null,
    },
    title: {
      type: String,
      default: 'My Tooltip',
    },
    trigger: {
      type: String,
      default: 'hover',
    },
    delay: {
      type: Number,
      default: 0,
    },
    placement: {
      type: String,
      default: 'top',
    },
    html: {
      type: Boolean,
      default: false,
    },
    popperConfig: {
      type: Object,
      default() {
        return null
      },
    },
  },
  data() {
    return {
      defaultIcon: 'info-circle',
      defaultIconFamily: 'fas',
    }
  },
  computed: {
    iconClass() {
      return [this.defaultIconFamily, this.defaultIcon]
    },
  },
  mounted() {
    //For custom template Tooltips, you need to create new component with
    // template: {
    //   type: String,
    //   default: '',
    // },
    var options = this.$props
    var ele = this.icon ? this.$el : this.$slots.default[0].elm
    new Tooltip(ele, options)
  },
}
</script>


